/**
 * Wo man war, als man weggegangen ist.
 *
 * Eine Liste mit 995 Zeilen, in der Mitte ein Tauchgang angetippt, zurück —
 * und die Liste steht wieder ganz oben. Auf dem Schreibtisch ist das
 * ärgerlich, auf einem Telefon ist es das Ende der Benutzung: Dort scrollt man
 * nicht eben mal zurück zu Nr. 431.
 *
 * Gemerkt wird je Pfad, nicht je Adresse: Die Suchbegriffe stehen im Anhang
 * der Adresse und ändern sich beim Tippen. Wer nach „Malediven" filtert und
 * einen Treffer öffnet, kommt an dieselbe Stelle zurück.
 */

const stellen = new Map();

/** So viele Pfade behält das Gedächtnis — mehr braucht niemand. */
const GRENZE = 30;

export function merke(pfad, y) {
  if (!pfad) return;
  // Neu einsortieren, damit die Reihenfolge im Map das Alter widerspiegelt.
  stellen.delete(pfad);
  stellen.set(pfad, Math.max(0, Math.round(y ?? 0)));
  if (stellen.size > GRENZE) stellen.delete(stellen.keys().next().value);
}

export function hole(pfad) {
  return stellen.get(pfad) ?? 0;
}

export function vergiss(pfad) {
  stellen.delete(pfad);
}

export function leere() {
  stellen.clear();
}

/**
 * Wird die gemerkte Stelle wiederhergestellt?
 *
 * Nur beim Zurückgehen. Wer von der Karte auf die Liste wechselt, will oben
 * anfangen — dort steht der jüngste Tauchgang, und das ist der Zweck der
 * Liste. Nur wer von einem Tauchgang zurückkommt, war schon einmal mitten
 * drin.
 */
export function stelleFuer(pfad, richtung) {
  return richtung === 'zurueck' ? hole(pfad) : 0;
}
